import React from 'react';
import { IconProps } from './types';

export const CheckedIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M20 4.6l-11 11-5-5L2.6 12l5.7 5.7c.2.2.4.3.7.3.3 0 .5-.1.7-.3L21.4 6 20 4.6z'
      />
    </svg>
  );
};
